import React from 'react';
import PropTypes from 'prop-types';
import { RecommendationModal } from './modal';
import { ConfirmForm } from './forms/confirm-form';

export class ConfirmFormModal extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    isApplyConfirmModalOpen: PropTypes.bool.isRequired,
    countRecommendation: PropTypes.number.isRequired,
    confirmApplyConfirmModal: PropTypes.func.isRequired,
    rejectApplyConfirmModal: PropTypes.func.isRequired,
  };

  render() {
    const {
      i18n,
      isApplyConfirmModalOpen,
      countRecommendation,
      confirmApplyConfirmModal,
      rejectApplyConfirmModal,
    } = this.props;

    return (
      <RecommendationModal
        isOpen={isApplyConfirmModalOpen}
        onCancel={rejectApplyConfirmModal}
      >
        <ConfirmForm
          title={
            countRecommendation === 1 ?
            i18n.getString('Summary_Card_Apply') :
            i18n.getString('Summary_Card_Apply_All')
          }
          content={
            countRecommendation === 1 ?
            i18n.getString('Recommendation_Apply_All_Confirm_Singular') :
            i18n.getString('Recommendation_Apply_All_Confirm', { count: countRecommendation })
          }
          confirmString={i18n.getString('Recommendation_Confirm')}
          cancelString={i18n.getString('Cancel')}
          onConfirm={confirmApplyConfirmModal}
          onCancel={rejectApplyConfirmModal}
          i18n={i18n}
        />
      </RecommendationModal>
    );
  }
}
